<template>
    <div classs="peomonitor">
        <div class="monitor_center">
            <div class="block lf">
            <el-cascader
                v-model="value"
                class="cascader_monitor"
                :options="options"
                ></el-cascader>
            </div>
            <div class="monitor_btn rf com_task" >
      
            </div>
        </div>
        <el-table :data="taskList" border style="width: 100%" class="exam_table"
        ref="multipleTable"
        >
        <el-table-column
            v-for="info in tHeadr" :key="info.key"     
            :property="info.key"
            :label="info.label"
            :width="info.width"
        >
        <template slot-scope="scope">
            {{scope.row[scope.column.property]}}  <!-- 渲染对应表格里面的内容 -->
        </template>
        </el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope" class="exam_btn">
                <el-button type="text" size="large" @click="hrefTo(scope)" >查看详情</el-button>
            </template>
        </el-table-column>
        </el-table>
        <page :count="count" :Page.sync='page' @pagenation='pagetion'></page>
    </div>
</template>
<script>
import page from '../Common/page'

export default{
    name:'makeup',
    data(){
        return{
            id:this.$route.query.id,
             taskList:[],
            tHeadr: [
                {
                    label: '姓名',
                    key: 'nickname',
                    width:'105'
                },
                {
                    label: '所属部门',
                    key: 'dep',
                    width:'290  '
                },
                {
                    label: '所属岗位',
                    key: 'post',
                    width:'290'
                },
                {
                    label:'补考期限',
                    key:'time',
                    width:'290'
                },
                {
                    label:'考试结果',
                    key:'states',
                    width:'117'
                },
                {
                    label:'考试次数',
                    key:'num',
                    width:'118'
                },
                {
                    label:'考试得分',
                    key:'grade',
                    width:'118'
                },
                {
                    label:'作答时长',
                    key:'result',
                    width:'119'
                },
            ],
            limit:10, //一页几条数据
            count:0, //数据总计
            page:1, //当前页数
        }
    },
    components:{
        page,
    },
     props:{
         taskListSear:{
            type:Array,
            default:()=>[],
        },
    },
    methods:{
hrefTo(id){
            console.log(id)
            var tid= id.row.user_id
            var eid= id.row.t_id
            this.$router.push({ path:'/examRecord',query:{id:tid,eid:eid}})
        },
    },
    watch:{
        taskListSear(){
            this.taskList=this.taskListSear
        }
    },
    mounted(){
        var data={
            service:'Examtask.Detail',
            id:this.id,
        }
        var tklist=[]
        this.$axios.post(this.HOME,this.$qs.stringify(data))
        .then(res=>{
            this.count=res.data.data.info.list.length
            for(var i=0;i<res.data.data.info.list.length;i++){
                tklist.push(res.data.data.info.list[i])
                if(res.data.data.info.list[i].states==1){
                    var levelTxt='及格'
                }
                
                else{
                    var levelTxt='不及格'
                }
                tklist[i].states=levelTxt
            }
            this.taskList=tklist
        })
    }
}
</script>


// WEBPACK FOOTER //
// src/components/task/makeup.vue